// frontend/packs/home.js

import 'components/home/featured-grid/featured-grid';
import 'components/home/why-vecteezy/why-vecteezy';
import 'components/home/unlock-vecteezy/unlock-vecteezy';
import 'home/trusted_by_component/trusted_by_component.css';
import 'home/landing/creator_community_component/creator_community_component.css';
import 'components/home/sign-up-free/sign-up-free';

import TrendingSearchesController from 'components/search/trending-searches/trending-searches-controller';
import UnlockVecteezyController from 'components/home/unlock-vecteezy/unlock-vecteezy-controller';
import TrustedByController from 'home/trusted_by_component/trusted-by-controller';

window.EezyStimulusApplication.register('trending-searches', TrendingSearchesController);
window.EezyStimulusApplication.register('unlock-vecteezy', UnlockVecteezyController);
window.EezyStimulusApplication.register('trusted-by', TrustedByController);
